import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from '@mui/material';
import { QuestionDTO } from '../../../../types/ApplicationQuestion';

interface EditSectionModalProps {
  open: boolean;
  section: QuestionDTO; // section.question_type should be SECTION
  onSave: (updated: QuestionDTO) => void;
  onClose: () => void;
}

/**
 * Modal for adding or editing a SECTION item in the application questions list.
 * Only allows editing the `question_text` (section title).
 */
const EditSectionModal: React.FC<EditSectionModalProps> = ({
  open,
  section,
  onSave,
  onClose,
}) => {
  const [title, setTitle] = useState<string>(section.question_text || '');

  // Keep local title in sync when a new `section` prop is passed in.
  useEffect(() => {
    setTitle(section.question_text || '');
  }, [section]);

  const handleSave = () => {
    const trimmed = title.trim();
    if (!trimmed) return; // safeguard; button is disabled otherwise
    onSave({ ...section, question_text: trimmed });
  };

  const isDirty = title.trim() !== (section.question_text || '').trim();
  const canSave = title.trim().length > 0 && isDirty;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {section.id.startsWith('temp-') ? 'New Section' : 'Edit Section'}
      </DialogTitle>

      <DialogContent>
        <TextField
          autoFocus
          margin="normal"
          label="Section Title"
          fullWidth
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Enter section title"
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleSave}
          variant="contained"
          disabled={!canSave}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditSectionModal;
